import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
// @ts-ignore
import useCollapse from 'react-collapsed';
import { ILink } from './interfaces';
import MobileNavbarDropdownLink from './mobile-navbar-dropdown-link';

interface IMobileNavbarNavbarProps {
  links: ILink[],
}

const MobileNavbar: FunctionComponent<IMobileNavbarNavbarProps> = ({
  links,
}) => {
  const { getCollapseProps, getToggleProps, isOpen } = useCollapse();
  return (
    <nav
      className="navbar flex items-center justify-between lg:justify-center flex-wrap fixed w-full bg-black lg:pt-4"
    >
      <div className="w-full flex flex-col lg:flex-row lg:justify-center">
        <div className="flex w-full lg:w-auto justify-between">
          <div className="flex items-center flex-shrink-0 text-white mr-6 p-6">
            <Link to="/">
              <img src="/images/stempeers_logo-02.png" width={45} height={45} alt="" />
            </Link>
          </div>
          <div className="flex lg:hidden items-center">
            <button
              className="flex-items-center px-3 py-2 text-white hover:text-white hover:border-white"
              {...getToggleProps()}
            >
              <svg className="fill-current h-5 w-5" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <title>Menu</title>
                <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
              </svg>
            </button>
          </div>
        </div>
        <ul className="bg-gray-900" {...getCollapseProps()}>
          {links.map((link, index) => (
            link.sublinks
              ? (<MobileNavbarDropdownLink key={index} link={link} />)
              : (
                <li key={index} className="text-white px-8 py-3 uppercase font-poppins text-xs">
                  <Link to={link.href}>
                    {link.text}
                  </Link>
                </li>
              )
          ))}
        </ul>
        <div className="hidden lg:flex text-white py-6 pl-8 items-center">
          <a className="hover:text-gray-700" href="https://www.facebook.com/STEMPeer15/">
            <i className="icon-facebook2 mr-3" />
          </a>
          <a className="hover:text-gray-700" href="https://twitter.com/Stempeer15?lang=en">
            <i className="icon-twitter-square mr-3" />
          </a>
          <a className="hover:text-gray-700" href="https://www.linkedin.com/company/phdcareersupportgroup/">
            <i className="icon-linkedin" />
          </a>
        </div>
      </div>
    </nav>
  );
};

export default MobileNavbar;
